class ValleansFooter extends HTMLElement {
  connectedCallback() {
    this.abortController?.abort();
    this.abortController = new AbortController();
    const { signal } = this.abortController;
    this.desktop = window.matchMedia('(min-width: 990px)');
    this.syncNavigation = () => {
      this.querySelectorAll('[data-footer-navigation]').forEach((details) => {
        details.open = this.desktop.matches;
        const summary = details.querySelector('summary');
        if (this.desktop.matches) summary.setAttribute('tabindex', '-1');
        else summary.removeAttribute('tabindex');
      });
    };
    this.syncNavigation();
    this.setAttribute('data-enhanced', '');
    this.desktop.addEventListener('change', this.syncNavigation, { signal });
    this.addEventListener('click', (event) => {
      if (this.desktop.matches && event.target.closest('[data-footer-navigation] > summary')) event.preventDefault();
    }, { signal });
    this.addEventListener('change', (event) => {
      if (event.target.matches('[data-footer-localization]')) event.target.form?.requestSubmit();
    }, { signal });
  }
  disconnectedCallback() {
    this.abortController?.abort();
  }
}
if (!customElements.get('vh-footer')) customElements.define('vh-footer', ValleansFooter);
